import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_PLATFORM, GET_PLATFORM_SUCCESS, GET_PLATFORM_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getPlatform({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/platforms`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_PLATFORM_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_PLATFORM_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_PLATFORM_ERROR, payload: error });
  }
}

export function* watchGetPlatform() {
  yield takeEvery(GET_PLATFORM, getPlatform);
}

function* getPlatformSaga() {
  yield all([fork(watchGetPlatform)]);
}

export default getPlatformSaga;